const menu = require('../../../../../components/menu/menu')
const dtHandler = require('../../../../../components/dt/dt-handler')


export function start(detail, htmlDt, htmlFc, client) {

  const menuElem = menuBody[detail.id]

  for (let i = 0; i < menuElem.length; i++) {
    menuElem[i].start(detail, htmlDt, htmlFc, client)
  }

  detail.html = menuElem
  detail.act = 'show'
  menu.start(detail)

}

const menuBody = {

  fullcontOptions: [
    {
      text: '',
      svg: 'print',
      class: ``, //same name as the title test
      dataDetail: ``,

      start: function (detail, htmlDt, htmlFc) {

        //if exist one check
        this.class = ``
        this.text = `Print`
        this.dataDetail = `data-detail='{
                                     "click": [
                                        {"dest":"ripple" },
                                        {"dest":"menu", "act":"hide"},
                                        {"dest":"clientSale", "elem":"fullcont", "entity":"sale", "reportName":"sale-invoice", "act":"pdfMenuFullcont"} ]}'`
      }/**/
    },
  ],

}/*menuBody*/


